// extracted by mini-css-extract-plugin
export default {"hero":"edit-image_hero__UvhOR","hero__image":"edit-image_hero__image__uHxNe"};